export default "__VITE_ASSET__B1eu3QiS__"